<ngx-page-container>
  <h1>Core</h1>
  <hr>
  <ngx-form-list #formList
    *ngIf="coreColumns != null"
    [columns]="coreColumns"
    [value]="data.cores"
    (editConfirm)="validate($event)"
  >
  </ngx-form-list>
</ngx-page-container>

